import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, NgZone, HostListener } from '@angular/core';
import * as skrollr from 'skrollr';
import { Router } from '@angular/router';
import { timer } from 'rxjs/observable/timer';
import {
  AccountService,
  HtmlHelper,
  MessageTypeCodes,
  PopupMessageSummaries,
  PopupMessageTypes,
  PopupService,
  UserRequest,
  RestService,
  ServerResponse, Configuration, AppConfig,
} from '../../shared/shared.module';
import { LandingService } from '../../shared/services/landing.service';
import { SlideInfo } from '../../shared/models/slide-info-model';

@Component({
    selector: 'app-welcome-page',
    templateUrl: './welcome-page.component.html',
    styleUrls: ['./welcome-page.component.scss']
})
export class WelcomePageComponent implements OnInit, AfterViewInit {

    public Config: Configuration;
    enableCatching = false;
    isLogged = false;
    SlidePlanning = new SlideInfo();
    SlideProducts = new SlideInfo();
    SlideTime = new SlideInfo();
    SlideCook = new SlideInfo();
    SlideMultiple = new SlideInfo();
    SlidePremium = new SlideInfo();
    SlideWelcome = new SlideInfo();

    constructor(
        private router: Router,
        private landingService: LandingService,
        private popupService: PopupService,
        private accountService: AccountService,
        private ngZone: NgZone,
        private restService: RestService
    ) {
        this.restService.urlGet<JSON>('/assets/Landing/landingText.json', { responseType: 'json' })
            .then(data => {
                const response: ServerResponse<SlideInfo> = data;
                this.saveSlidesInfo(response.Result.Resultset);
            });
    }
    authorizationPopupDisplayed = false;
    loginPopupDisplayed = false;
    signupPopupDisplayed = false;
    restorationPopupDisplayed = false;
    browserIsOld = false;
    browserIsUnknow = true;
    user = new UserRequest();
    passwordRep = '';
    redirect = '';
    skrollr: any;
    isMobile = false;
    windowWidth: number = window.innerWidth;

    @ViewChild('signinEmail') signinLogin: ElementRef;
    @ViewChild('signinPassword') signinPassword: ElementRef;
    @ViewChild('registerEmail') registerLogin: ElementRef;
    @ViewChild('registerPassword') registerPassword: ElementRef;
    @ViewChild('registerPasswordRep') registerPasswordRep: ElementRef;
    @ViewChild('restorationEmail') restorationLogin: ElementRef;

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.windowWidth = event.target.innerWidth;

        this.isMobile = HtmlHelper.checkMobile(this.windowWidth);
        this.destroySkrollr();
    }

    ngOnInit() {
        this.Config = AppConfig.config;
        this.isMobile = HtmlHelper.checkMobile(this.windowWidth);
        this.accountService.isAuthenticated().then(result => {
            this.isLogged = (result.isLoggedIn && !result.isAnonymous);
        });
        if (!this.isMobile) { this.initSkrollr(); }
        this.checkBrowser();
        if (this.accountService.returnUrl) {
            this.openLoginDialog();
            this.accountService.returnUrl = null;
        }
    }

    ngAfterViewInit() {
        if (this.skrollr) { this.skrollr.refresh(); }
    }

    initSkrollr() {
        this.skrollr = skrollr.init(
            {
                smoothScrolling: true,
                easing: {
                    shake: function (p) {
                        return Math.sin(p * 10 * Math.PI);
                    }
                }
            }
        );
    }

    destroySkrollr() {
        const _skrollr = skrollr.get();

        if (!this.isMobile && _skrollr === undefined) {
            this.initSkrollr();
        } else if (this.isMobile && _skrollr !== undefined) {
            this.skrollr.destroy();
        }
    }

    scrollToElement(elementTag) {
        const element_to_scroll_to = document.getElementById(elementTag);
        element_to_scroll_to.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }

    scrollTop() {
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }

    openSignupDialog() {
        this.landingService.changeUser(this.user);
        this.landingService.toggleSignupDialog(true);
    }

    openLoginDialog() {
        if (!this.user.Email || !this.user.HPassword) {
            this.landingService.changeUser(this.user);
            this.landingService.toggleLoginDialog(true);
            this.user = new UserRequest();
            return;
        }

        this.landingService.callLogin(this.user);
        this.user = new UserRequest();
    }

    openEmailSendDialog() {
        this.landingService.toggleSignupDialog(false);
        this.landingService.toggleLoginDialog(false);
        this.landingService.toggleEmailSendDialog(true);
    }


    checkForEnter(event): boolean {
        return event.keyCode === 13;
    }

    saveSlidesInfo(data: SlideInfo[]) {
        const allSLides = data;
        this.SlideWelcome = this.findCurrentSlide('welcome', allSLides);
        this.SlidePlanning = this.findCurrentSlide('planning', allSLides);
        this.SlideProducts = this.findCurrentSlide('products', allSLides);
        this.SlideTime = this.findCurrentSlide('time', allSLides);
        this.SlideCook = this.findCurrentSlide('cook', allSLides);
        this.SlideMultiple = this.findCurrentSlide('multiple', allSLides);
        this.SlidePremium = this.findCurrentSlide('premium', allSLides);
    }

    findCurrentSlide(slideName: string, array: SlideInfo[]): SlideInfo {

        const slideIndex: SlideInfo = array.find(slide => slide.id === slideName);

        return slideIndex;
    }

    // TODO: вынести в сервис поторябщийся функционал с валидацией и вызовами для регистрации и логина (повторяется в лендинге)
    register(event?: any) {
        if (event && !this.checkForEnter(event)) {
            return;
        }
        if (!HtmlHelper.checkValidity(this.user.Email, this.registerLogin)) {
            return;
        }
        const dogIndex = this.user.Email.indexOf('@');
        const dotIndex = this.user.Email.substr(dogIndex).indexOf('.');
        const lengthIndex = this.user.Email.substr(dogIndex).substr(dotIndex);
        if ((dogIndex === -1) || (dotIndex === -1) || (lengthIndex.length < 1)) {
            if (this.registerLogin.nativeElement) {
                this.registerLogin.nativeElement.setCustomValidity('Некорректный формат почты!');
                this.registerLogin.nativeElement.reportValidity();
            }
            return;
        }

        if (!HtmlHelper.checkValidity(this.user.HPassword, this.registerPassword)) {
            return;
        }
        if (!HtmlHelper.checkValidity(this.passwordRep, this.registerPasswordRep) || this.passwordRep !== this.user.HPassword) {
            if (this.registerPasswordRep.nativeElement) {
                this.registerPasswordRep.nativeElement.setCustomValidity('Пароли не совпадают!');
                this.registerPasswordRep.nativeElement.reportValidity();
            }
            return;
        }

        this.accountService.register(this.user).then(x => {
            if (x) {
                this.user = new UserRequest();
                this.passwordRep = null;
                if (x.Result.ReturnCode > 0) {
                    this.signupPopupDisplayed = false;
                    if (x.Result.Message === 'OK') {
                        this.popupService.clearMessages();
                        this.openEmailSendDialog();
                    }
                    return;
                }
                this.showMessage(MessageTypeCodes.RegistrationError, x.Result.Message);
                return;
            }
            this.showMessage(MessageTypeCodes.RegistrationError, 'Ошибка отправки, пожалуйста попробуйте еще раз.');
            return;
        }, () => {
          this.showMessage(MessageTypeCodes.RegistrationError, 'Ошибка отправки, пожалуйста попробуйте еще раз.');
        });
    }

    loginWithFacebook(): void {
        this.accountService.logInFb()
            .then(() => {
                this.detectAuthClosePromise();
            });
    }

    loginWithVk() {
        this.accountService.logInVk()
            .then(() => {
                this.detectAuthClosePromise();
            });
    }

    loginWithOk() {
        this.accountService.logInOk()
            .then(() => {
                this.detectAuthClosePromise();
            });
    }

    loginWithGoogle() {
        this.accountService.logInGoogle()
            .then(() => {
                this.detectAuthClosePromise();
            });
    }

    detectAuthClosePromise() {
        const timerSubscription = timer(0, 100).subscribe(() => {
            this.accountService.isAuthenticated().then(result => {
                if (result) {
                    timerSubscription.unsubscribe();
                    let redirectUrl = 'welcome';
                    if (this.accountService.returnUrl) {
                      redirectUrl = this.accountService.returnUrl;
                      this.accountService.returnUrl = null;
                    }
                    window.location.pathname = redirectUrl;
                }
            });
        });
    }


    showMessage(code: MessageTypeCodes, message: string) {
        let severity = '';
        let info = '';
        switch (code) {
            case MessageTypeCodes.WrongLoginOrPassword:
                severity = PopupMessageTypes.Error;
                info = PopupMessageSummaries.Error;
                if (message === 'Объект не найден или недостаточно прав на операцию с этим объектом') {
                    message = 'Неправильный логин или пароль!';
                }
                break;
            case MessageTypeCodes.RegistrationError:
                severity = PopupMessageTypes.Error;
                info = PopupMessageSummaries.Error;
                message = `Ошибка при регистрации! ${message}`;
                break;
            case MessageTypeCodes.Error:
                severity = PopupMessageTypes.Error;
                info = PopupMessageSummaries.Error;
                break;
            case MessageTypeCodes.Success:
                severity = PopupMessageTypes.Success;
                info = PopupMessageSummaries.Success;
                break;
            case MessageTypeCodes.RegistrationSuccess:
                severity = PopupMessageTypes.Success;
                info = PopupMessageSummaries.Success;
                message = message || 'Регистрация выполнена!';
                break;
            case MessageTypeCodes.SignInSuccess:
                severity = PopupMessageTypes.Success;
                info = PopupMessageSummaries.Success;
                message = 'Вход выполнен!';
                break;
            default:
                severity = PopupMessageTypes.Info;
                info = PopupMessageSummaries.Success;
                break;
        }
        this.popupService.showMessage({ severity: severity, summary: info, detail: message });
    }

    checkBrowser() {
        const nAgt = navigator.userAgent;
        let browserName = '';
        let fullVersion = '' + parseFloat(navigator.appVersion);
        let majorVersion = parseInt(navigator.appVersion, 10);
        let verOffset, ix;

        // In Opera, the true version is after "Opera" or after "Version"


        if ((verOffset = nAgt.indexOf('MSIE')) !== -1) {
            browserName = 'Microsoft Internet Explorer';
            fullVersion = nAgt.substring(verOffset + 5);
        }

        if ((verOffset = nAgt.indexOf('Chrome')) !== -1) {
            browserName = 'Chrome';
            fullVersion = nAgt.substring(verOffset + 7);
        }

        if ((verOffset = nAgt.indexOf('Safari')) !== -1 && (verOffset = nAgt.indexOf('Chrome')) === -1) {
            browserName = 'Safari';
            fullVersion = nAgt.substring(verOffset + 7);
            if ((verOffset = nAgt.indexOf('Version')) !== -1) {
                fullVersion = nAgt.substring(verOffset + 8);
            }
        }

        if ((verOffset = nAgt.indexOf('OPR')) !== -1) {
            browserName = 'Opera';
            fullVersion = nAgt.substring(verOffset + 4);
        }

        if ((verOffset = nAgt.indexOf('Firefox')) !== -1) {
            browserName = 'Firefox';
            fullVersion = nAgt.substring(verOffset + 8);
        }

        if ((verOffset = nAgt.indexOf('Edge')) !== -1) {
            browserName = 'Edge';
            fullVersion = nAgt.substring(verOffset + 5);
        }

        if ((ix = fullVersion.indexOf(';')) !== -1) {
            fullVersion = fullVersion.substring(0, ix);
        }
        if ((ix = fullVersion.indexOf(' ')) !== -1) {
            fullVersion = fullVersion.substring(0, ix);
        }

        majorVersion = parseInt('' + fullVersion, 10);

        if (isNaN(majorVersion)) {
            fullVersion = '' + parseFloat(navigator.appVersion);
            majorVersion = parseInt(navigator.appVersion, 10);
        }

        if (browserName.indexOf('Chrome') > -1) {
            this.browserIsUnknow = false;
            if (majorVersion >= 61) {
                this.browserIsOld = false;
                return;
            }
        }

        if (browserName.indexOf('Safari') > -1) {
            this.browserIsUnknow = false;
            if (majorVersion > 10) {
                this.browserIsOld = false;
                return;
            }
        }

        if (browserName.indexOf('Firefox') > -1) {
            this.browserIsUnknow = false;
            if (majorVersion > 59) {
                this.browserIsOld = false;
                return;
            }
        }
        if (browserName.indexOf('Edge') > -1) {
            this.browserIsUnknow = false;
            if (majorVersion > 15) {
                this.browserIsOld = false;
                return;
            }
        }
        if (browserName.indexOf('Opera') > -1) {
            this.browserIsUnknow = false;
            if (majorVersion >= 48) {
                this.browserIsOld = false;
                return;
            }
        }

        if (browserName.indexOf('Netscape') > -1) {
            this.browserIsUnknow = true;
            this.browserIsOld = true;
        }

        if (browserName.indexOf('Microsoft Internet Explorer') > -1) {
            this.browserIsUnknow = false;
            this.browserIsOld = true;
        }

        if (nAgt.indexOf('Trident') !== -1 && nAgt.indexOf('rv:11') !== -1) {
            this.browserIsUnknow = false;
            this.browserIsOld = false;
            return;
        }

        if (this.browserIsOld) {
            this.landingService.toggleBrowserWarning(true);
        }

    }

    callAuthorization() {
      this.landingService.toggleSignupDialog(false);
      this.landingService.toggleLoginDialog(false);
      this.landingService.toggleAuthorizationDialog(true);
    }

    goLink(url) {
      if (url === 'outsideLink') {
        window.location.href = this.Config.linkForOrderReadyMenu;
      } else {
        this.router.navigateByUrl(url);
      }
    }

}



// WEBPACK FOOTER //
// ./src/app/landing/welcome-page/welcome-page.component.ts